import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

@Component({
    selector: 'shop-amount-select',
    templateUrl: './shop.amount-select.component.html',
})

export class ShopAmountSelectComponent implements OnInit, OnChanges {
    // Constants
    readonly MAX_AMOUNT: number = 30;
    readonly ADD_AMOUNT: number = 10;

    // The maximum amount of items that can be selected.
    @Input() maxAmount: number;

    // The amount of items that are currently selected.
    @Input() itemCount: number;

    @Input() itemName: string;

    // Force the max amount to be 30
    @Input() forceMax: boolean = false;
    // Disable the input field

    @Input() isDisabled: boolean = false;

    // Event emitter for the amount change
    @Output() amountChange: EventEmitter<number> = new EventEmitter<number>();

    constructor() { }

    ngOnInit(): void {
        this.capAmount();
    }

    ngOnChanges(): void {
        this.capAmount();
    }

    /**
     * If there is maxAmount set or if it is not a valid number
     * cap the amount to the maximum amount of items available.
     */
    capAmount = () => {
        // if no maxAmount is set or it is not a valid number
        if (this.maxAmount === undefined || this.maxAmount === Infinity || this.maxAmount < 1 || isNaN(this.maxAmount)) {
            let maxSelect = this.forceMax ? this.MAX_AMOUNT : this.itemCount;

            if (maxSelect < this.MAX_AMOUNT) {
                maxSelect = this.MAX_AMOUNT;
            }
            
            this.maxAmount = Math.min(maxSelect, Math.max(1, this.maxAmount));
        }
        // if maxAmount is bigger MAX_AMOUNT but MAX_AMOUNT is forced
        if (this.forceMax === true && this.maxAmount > this.MAX_AMOUNT) {
            this.maxAmount = this.MAX_AMOUNT;
        }
        // if maxAmount is bigger MAX_AMOUNT but the itemCount is smaller than MAX_AMOUNT
        if (this.maxAmount > this.MAX_AMOUNT && this.itemCount < this.MAX_AMOUNT) {
            this.maxAmount = this.MAX_AMOUNT;
        }
        // if maxAmount is bigger MAX_AMOUNT but the itemCount is smaller than MAX_AMOUNT
        if (this.maxAmount > this.MAX_AMOUNT && this.itemCount >= this.MAX_AMOUNT) {
            this.maxAmount = this.itemCount + this.ADD_AMOUNT;   // plus ADD_AMOUNT to give some room for the user to select more items
        }
    }

    /**
     * Update the amount of items that are currently selected.
     * @param amount 
     */
    onAmountChange(amount: string) {
        this.amountChange.emit(parseInt(amount));
    }
}
